import _ from '@/utils/lodash-optimized'
import React from 'react'

import { ReligiousPreferenceCodes, MilitaryCodes } from '../../../../../lib/Codes'
import { LifeStyleQuestionnaire } from '../../../../../lib/Questionnaires'
import {
  YesNoRadioOptions,
  bindTargetMixin,
  CancelButton,
  DateInput,
  MaskedTextInput,
  QuestionRadioButtonInput,
  SaveButton,
  SelectInput,
  TextInput
} from '../../../../shared/FormBuilder'

class LifestyleForm extends bindTargetMixin(React.Component) {
  constructor (props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  forDisplay = (list, attr = 'label') =>
    _.sortBy(
      _.map(list, a =>
        _.merge(a, { label: _.startCase(a[attr].toLowerCase()) })),
      a => a.label.toLowerCase()
    )

  valueCheck (field, val) {
    return field === val
  }

  renderDietAndExercise () {
    return (
      <div>
        <QuestionRadioButtonInput
          question={LifeStyleQuestionnaire.dietaryRestriction.question}
          name={LifeStyleQuestionnaire.dietaryRestriction.name}
          yesNo
        />
        <TextInput
          label={LifeStyleQuestionnaire.dietaryRestrictionDetails.question}
          name={LifeStyleQuestionnaire.dietaryRestrictionDetails.name}
          required={this.valueCheck(this.state.value.dietaryRestriction, 'yes')}
        />
        <QuestionRadioButtonInput
          question={LifeStyleQuestionnaire.dietaryPreference.question}
          name={LifeStyleQuestionnaire.dietaryPreference.name}
          yesNo
        />
        <TextInput
          label={LifeStyleQuestionnaire.dietaryPreferenceDetails.question}
          name={LifeStyleQuestionnaire.dietaryPreferenceDetails.name}
          required={this.valueCheck(this.state.value.dietaryPreference, 'yes')}
        />
        <div className='row'>
          <div className='col-xs-12 col-sm-4'>
            <TextInput
              label={LifeStyleQuestionnaire.exerciseFrequency.question}
              name={LifeStyleQuestionnaire.exerciseFrequency.name}
            />
          </div>

          <div className='col-xs-12 col-sm-8'>
            <TextInput
              label={LifeStyleQuestionnaire.exerciseType.question}
              name={LifeStyleQuestionnaire.exerciseType.name}
            />
          </div>
        </div>
      </div>
    )
  }

  renderCultureQuestions () {
    return (
      <div>
        <div className='nh-margin-top-2'>
          <QuestionRadioButtonInput
            question={LifeStyleQuestionnaire.culturalNeeds.question}
            name={LifeStyleQuestionnaire.culturalNeeds.name}
            yesNo
          />
        </div>
        <TextInput
          label={LifeStyleQuestionnaire.culturalNeedsDetails.question}
          name={LifeStyleQuestionnaire.culturalNeedsDetails.name}
          required={this.valueCheck(this.state.value.culturalNeeds, 'yes')}
        />
        <div className='nh-margin-top-2'>
          <QuestionRadioButtonInput
            question={LifeStyleQuestionnaire.religiousActivities.question}
            radioButtons={YesNoRadioOptions}
            fieldName={LifeStyleQuestionnaire.religiousActivities.name}
          />
        </div>
        <div className='row'>
          <div className='col-xs-12 col-sm-6 col-md-6'>
            <SelectInput
              name={LifeStyleQuestionnaire.religiousPreference.name}
              options={ReligiousPreferenceCodes}
              label={LifeStyleQuestionnaire.religiousPreference.question}
            />
          </div>
          <div className='col-xs-12 col-sm-6 col-md-6'>
            <TextInput
              label={LifeStyleQuestionnaire.religiousOrganization.question}
              name={LifeStyleQuestionnaire.religiousOrganization.name}
            />
          </div>
          <div className='col-xs-12 col-sm-6 col-md-6'>
            <TextInput
              label={LifeStyleQuestionnaire.religiousLeader.question}
              name={LifeStyleQuestionnaire.religiousLeader.name}
            />
          </div>
          <div className='col-xs-12 col-sm-6'>
            <MaskedTextInput
              mask='111.111.1111'
              name={LifeStyleQuestionnaire.religiousOrganizationNumber.name}
              label={
                LifeStyleQuestionnaire.religiousOrganizationNumber.question
              }
              hintText='Phone Number'
            />
          </div>
        </div>
        <div className='nh-margin-top-2'>
          <QuestionRadioButtonInput
            question={LifeStyleQuestionnaire.spiritualDistress.question}
            name={LifeStyleQuestionnaire.spiritualDistress.name}
            yesNo
          />
        </div>
        <TextInput
          label={LifeStyleQuestionnaire.spiritualDistressDetails.question}
          name={LifeStyleQuestionnaire.spiritualDistressDetails.name}
          required={this.valueCheck(this.state.value.spiritualDistress, 'yes')}
        />
      </div>
    )
  }

  renderPersonalInterest () {
    return (
      <div className='row'>
        <div className='col-xs-12'>
          <TextInput
            label={LifeStyleQuestionnaire.hobbies.question}
            name={LifeStyleQuestionnaire.hobbies.name}
          />
        </div>
        <div className='col-xs-12'>
          <TextInput
            label={LifeStyleQuestionnaire.pets.question}
            name={LifeStyleQuestionnaire.pets.name}
          />
        </div>
        <div className='col-xs-12'>
          <TextInput
            label={LifeStyleQuestionnaire.socialClubs.question}
            name={LifeStyleQuestionnaire.socialClubs.name}
          />
        </div>
        <div className='col-xs-12'>
          <TextInput
            label={LifeStyleQuestionnaire.recentTravel.question}
            name={LifeStyleQuestionnaire.recentTravel.name}
          />
        </div>
      </div>
    )
  }

  servedMilitary () {
    return (
      <div>
        <div className='row'>
          <div className='col-xs-12 col-sm-6 margin-top'>
            <SelectInput
              options={MilitaryCodes}
              label={LifeStyleQuestionnaire.branch.question}
              name={LifeStyleQuestionnaire.branch.name}
            />
          </div>

          <div className='col-xs-12 col-sm-3 mui-date-picker-extended margin-top'>
            <DateInput
              label={LifeStyleQuestionnaire.startDate.question}
              name={LifeStyleQuestionnaire.startDate.name}
            />
          </div>

          <div className='col-xs-12 col-md-3 mui-date-picker-extended margin-top'>
            <DateInput
              label={LifeStyleQuestionnaire.endDate.question}
              name={LifeStyleQuestionnaire.endDate.name}
            />
          </div>
        </div>
        <div className='nh-margin-top-2'>
          <QuestionRadioButtonInput
            question={LifeStyleQuestionnaire.militaryCombat.question}
            radioButtons={YesNoRadioOptions}
            name={LifeStyleQuestionnaire.militaryCombat.name}
          />
        </div>
      </div>
    )
  }

  validateMilitary () {
    const { name } = LifeStyleQuestionnaire.branch
    const start = LifeStyleQuestionnaire.startDate.name
    const end = LifeStyleQuestionnaire.endDate.name
    const combat = LifeStyleQuestionnaire.militaryCombat.name

    if (
      this.state.value &&
      this.state.value.militaryService === 'no' &&
      (this.state.value[name] ||
        this.state.value[start] ||
        this.state.value[end] ||
        this.state.value[combat])
    ) {
      const newState = this.state.value
      newState[name] = undefined
      newState[start] = undefined
      newState[end] = undefined
      newState[combat] = undefined
      this.setState({
        value: newState
      })
    }
  }

  renderMilitary () {
    return (
      <div>
        <QuestionRadioButtonInput
          question={LifeStyleQuestionnaire.militaryService.question}
          radioButtons={YesNoRadioOptions}
          name={LifeStyleQuestionnaire.militaryService.name}
        />

        <QuestionRadioButtonInput
          question={LifeStyleQuestionnaire.militaryBenefits.question}
          radioButtons={YesNoRadioOptions}
          name={LifeStyleQuestionnaire.militaryBenefits.name}
        />

        {this.state.value.militaryService === 'yes'
          ? this.servedMilitary()
          : ''}
      </div>
    )
  }

  handleSubmit () {
    const { onSubmit } = this.props
    onSubmit({ ...this.state.value })
  }

  componentDidUpdate () {
    this.validateMilitary()
  }

  render () {
    const { value } = this.state

    const disableSave =
      (value.culturalNeeds === 'yes' && !value.culturalNeedsDetails) ||
      (value.dietaryPreference === 'yes' && !value.dietaryPreferenceDetails) ||
      (value.dietaryRestriction === 'yes' &&
        !value.dietaryRestrictionDetails) ||
      (value.spiritualDistress === 'yes' && !value.spiritualDistressDetails)

    return (
      <div>
        <div className='row'>
          <h2>Dietary and Exercise</h2>
        </div>

        {this.renderDietAndExercise()}

        <div className='row margin-top'>
          <h2>Culture and Spiritual</h2>
        </div>

        {this.renderCultureQuestions()}

        <div className='row margin-top'>
          <h2>Personal Interests</h2>
        </div>

        {this.renderPersonalInterest()}

        <div className='row margin-top'>
          <h2 className='col-xs-12'>Military Service</h2>
        </div>

        {this.renderMilitary()}
        <div className='row end-xs margin-top nh-form-margin-top'>
          <div className='col-xs-12'>
            <CancelButton
              formKey={this.props.formKey}
              onClick={this.props.cancel}
            />

            <SaveButton
              formKey={this.props.formKey}
              disabled={disableSave}
              onClick={this.handleSubmit}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default LifestyleForm
